import "../img/about/about-banner.png";
import "../img/icons/apprentice-icon.jpg";
